import React, {createContext, useEffect, useState} from "react"
import parseToken from "../../../helpers/parseToken"
import {getLayoutConfigSetting} from "../../../services/api/apiSetting"
import {getApParam2, getTenants} from "../../../services/api/apiCommon"
import {message} from "antd"

export const Context = createContext({})

export const Provider = (props) => {
    const info = parseToken()
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [filters, setFilters] = useState({
        layoutType: [],
        layoutBlock: [],
        layoutField: [],
        fieldType: []
    })
    const [listLayout, setListLayout] = useState([])
    const [tenant, setTenant] = useState([])
    const [listLayoutType, setListLayoutType] = useState([])
    const [listLayoutBlock, setListLayoutBlock] = useState([])
    const [listLayoutField, setListLayoutField] = useState([])
    const [listFieldType, setListFieldType] = useState([])

    const _onChangeFilter = (name, value) => {
        setFilters({
            ...filters,
            [name]: value
        })
    }

    const _fetchListSettingLayout = async () => {
        setLoading(true)
        setError('')

        try {
            const payload = {
                ...filters
            }

            const response = await getLayoutConfigSetting(payload, info.sub)

            const {success, data, error_message} = response

            if (parseInt(success) !== 1) {
                setLoading(false)
                setListLayout([])
                return setError(error_message)
            }

            setLoading(false)
            setListLayout(data)
        } catch (e) {
            setLoading(false)
            setError(e.message)
        }
    }

    const _fetchListFilter = async () => {
        try {
            const payload = {
                "parType": ["DEFAULT"],
                "parCode": ["LAYOUT_TYPE", "LAYOUT_BLOCK", "LAYOUT_FIELD", "FIELD_TYPE"]
            }
            const response = await getApParam2(payload)

            const {success, data, error_message} = response

            if (parseInt(success) !== 1) {
                return message.error(error_message)
            }

            const _listLayoutType = data.filter(item => item.parCode === 'LAYOUT_TYPE').map(item => {
                return {
                    name: item.parName,
                    value: item.parName
                }
            })

            const _listLayoutBlock = data.filter(item => item.parCode === 'LAYOUT_BLOCK').map(item => {
                return {
                    name: item.parName,
                    value: item.parName
                }
            })

            const _listLayoutField = data.filter(item => item.parCode === 'LAYOUT_FIELD').map(item => {
                return {
                    name: item.parName,
                    value: item.parName
                }
            })

            const _listFieldType = data.filter(item => item.parCode === 'FIELD_TYPE').map(item => {
                return {
                    name: item.parName,
                    value: item.parName
                }
            })

            setListLayoutType(_listLayoutType)
            setListLayoutBlock(_listLayoutBlock)
            setListLayoutField(_listLayoutField)
            setListFieldType(_listFieldType)
        } catch (e) {
            message.error(e.message)
        }
    }

    const _fetchListTenant = async () => {
        try {
            const response = await getTenants({}, info.sub)

            const {success, data, error_message} = response

            if (parseInt(success) !== 1) {
                return message.error(error_message)
            }

            setTenant([...data])
        } catch (e) {
            message.error(e.message)
        }
    }

    useEffect(() => {
        _fetchListTenant()
        _fetchListFilter()
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        _fetchListSettingLayout()

        return () => {
            setLoading(false)
            setError('')
        }
        // eslint-disable-next-line
    }, [filters])

    return (
        <Context.Provider
            value={{
                loading,
                error,
                filters,
                listLayout,
                tenant,
                listLayoutType,
                listLayoutBlock,
                listLayoutField,
                listFieldType,
                onChangeFilter: _onChangeFilter,
                getListLayout: _fetchListSettingLayout
            }}
        >
            {props.children}
        </Context.Provider>
    )
}

export {
    Context as SettingLayoutContext,
    Provider as SettingLayoutProvider
} from "./SettingLayoutContext"
